__turbopack_context__.v({
  "passport_button": "TeBjGq_passport_button",
  "passport_hover_overlay": "TeBjGq_passport_hover_overlay",
  "passport_hover_overlay_text": "TeBjGq_passport_hover_overlay_text",
});
